<div class="loader-container" *ngIf="!view">
  <app-loading-dots size="5px"></app-loading-dots>
</div>
<div *ngIf="view">
  <app-view [items]="view.data?.content" [info]="view?.data"></app-view>
</div>
